import { numberOrStringAsNumber } from './numberOrStringAsNumber'

const mn = `[cynqueModules/utils/incrementNumberOrStringAsNumber]`

export function incrementNumberOrStringAsNumber(
  inputValue: number | string | null | undefined
) {
  const fn = `${mn} incrementNumberOrStringAsNumber |`
  const outputValue = numberOrStringAsNumber(inputValue) + 1
  console.debug(`${fn} inputValue: ${inputValue} outputValue: ${outputValue}`)
  return outputValue
}
